
export const getIncompatibleRuleForFeatures = (features) => {
    let formattedText = "";
    let firstFeature = true;
    features.forEach(f => {
       if (!firstFeature) {
           formattedText += ", ";
       } else {
           firstFeature = false;
       }
       formattedText += f.name;
    });

    return formattedText;
};
